import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class Login12 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errorMessage: '',
      successMessage: '',
      isLoading: false,
    };
  }

  // Handle input
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, errorMessage: '', successMessage: '' });
  };

  // Submit login
  handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = this.state;

    if (!email || !password) {
      this.setState({ errorMessage: 'Email and Password are required!' });
      return;
    }

    this.setState({ isLoading: true, errorMessage: '', successMessage: '' });

    try {
      const response = await fetch('/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.toLowerCase(), password }),
      });

      const data = await response.json();

      if (response.ok) {
        this.setState({
          successMessage: '✅ Login successful! Redirecting...',
          errorMessage: '',
        });

        // Redirect after short delay
        setTimeout(() => {
          this.props.history.push({
            pathname: '/driverocr',
            state: { email: data.email, balance: data.balance },
          });
        }, 800);
      } else {
        this.setState({
          errorMessage: data.message || '❌ Invalid credentials. Please try again.',
          successMessage: '',
        });
      }
    } catch (error) {
      console.error('Login error:', error);
      this.setState({
        errorMessage: '⚠️ Unable to connect to server.',
        successMessage: '',
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { email, password, errorMessage, successMessage, isLoading } = this.state;

    // shared style for internal links
    const linkStyle = {
      color: '#007bff',
      textDecoration: 'none',
      fontSize: '0.9rem',
      margin: '0 5px',
    };

    const hoverEffect = (e, active) => {
      e.target.style.textDecoration = active ? 'underline' : 'none';
    };

    return (
      <div className="login-container d-flex align-items-center justify-content-center">
        <div className="text-center" style={{ width: '100%', maxWidth: '420px' }}>
          {/* Header */}
          <img className="logo mb-3" src={logo} alt="Logo" />
          <h3>Welcome back</h3>
          <p className="text-muted">Please log in to verify your bank slips.</p>

          {/* Home Link */}
          <div className="mb-2">
            <Link
              to="/"
              style={linkStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              🏠 Back to Home
            </Link>
          </div>

          <div className="card mt-3 shadow-sm">
            <div className="card-body">
              <form onSubmit={this.handleSubmit}>
                {/* Email */}
                <div className="form-group mb-3 text-start">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={email}
                    onChange={this.handleInputChange}
                    required
                  />
                </div>

                {/* Password */}
                <div className="form-group mb-3 text-start">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    className="form-control"
                    placeholder="Enter your password"
                    value={password}
                    onChange={this.handleInputChange}
                    required
                  />
                </div>

                {/* Alerts */}
                {errorMessage && <div className="alert alert-danger py-2">{errorMessage}</div>}
                {successMessage && <div className="alert alert-success py-2">{successMessage}</div>}

                {/* Login Button */}
                <button type="submit" className="btn btn-dark w-100" disabled={isLoading}>
                  {isLoading ? 'Logging in…' : 'Login'}
                </button>

                {/* 🔹 Forgot Password + Register Links */}
                <div style={{ marginTop: '10px' }}>
                  <Link
                    to="/forgetpassword"
                    style={linkStyle}
                    onMouseEnter={(e) => hoverEffect(e, true)}
                    onMouseLeave={(e) => hoverEffect(e, false)}
                  >
                    Forgot password?
                  </Link>
                  {' | '}
                  <Link
                    to="/register"
                    style={linkStyle}
                    onMouseEnter={(e) => hoverEffect(e, true)}
                    onMouseLeave={(e) => hoverEffect(e, false)}
                  >
                    Create account
                  </Link>
                </div>
              </form>

              {/* Footer */}
              <div className="mt-4 text-center small text-muted">
                <p>Powered by</p>
                <img src={logo2} alt="Logo 2" style={{ width: '80px', opacity: 0.85 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login12);
